import { createReducer, createActions } from 'reduxsauce'
import { filter, find } from 'lodash'

// Initial State
export const initialState = {
    mcList: [],
    mcTarget: null, // current mc target for creating, updating or deleting
    configFile: {
        current: null,
        default: null,
        schema: {
            main: null,
            refs: null
        }
    }
}

// Types and Action Creators
const { Types, Creators } = createActions(
    {
        clean: null,
        setMcList: ['list'],
        addMcToList: ['mc'],
        updateMcAtList: ['mc'],
        deleteMcFromList: ['uuid'],
        setMcTarget: ['uuid'],
        cleanMcTarget: null,
        setConfigFile: ['configFile'],
        setCurrentInConfigFile: ['current'],

        // Async actions
        requestMcList: null,
        handleMcList: ['response'],
        requestNewMc: ['mc'],
        handleNewMc: ['response'],
        requestUpdateMc: ['mc'],
        handleUpdateMc: ['response'],
        requestUpdateMcPassword: ['mc'],
        handleUpdateMcPassword: ['response'],
        requestDeleteMc: ['uuid'],
        handleDeleteMc: ['response'],
        requestConfigFileData: null,
        handleConfigFileData: ['response'],
        requestUpdateConfigFile: ['json'],
        handleUpdatedConfigFile: ['response'],
        handleServerError: ['response'],
    },
    {
        prefix: 'SUPER_ADMIN_'
    }
)

export const SuperAdminTypes = Types

// Reducers and Handlers
export const handlers = {
    [Types.CLEAN]: () => ({ ...initialState }),
    [Types.SET_MC_LIST]: (state = initialState, { list }) => ({ ...state, mcList: list }),
    [Types.ADD_MC_TO_LIST]: (state = initialState, { mc }) => ({ ...state, mcList: [...state.mcList, mc] }),
    [Types.UPDATE_MC_AT_LIST]: (state = initialState, { mc }) => ({
        ...state,
        mcList: state.mcList.map(prevMc => (prevMc.uuid === mc.uuid ? { ...prevMc, ...mc } : prevMc))
    }),
    [Types.DELETE_MC_FROM_LIST]: (state = initialState, { uuid }) => ({ ...state, mcList: filter(state.mcList, m => m.uuid !== uuid) }),
    [Types.SET_MC_TARGET]: (state = initialState, { uuid }) => ({ ...state, mcTarget: find(state.mcList, m => m.uuid === uuid) }),
    [Types.CLEAN_MC_TARGET]: (state = initialState) => ({ ...state, mcTarget: initialState.mcTarget }),
    [Types.SET_CONFIG_FILE]: (state = initialState, { configFile }) => ({ ...state, configFile }),
    [Types.SET_CURRENT_IN_CONFIG_FILE]: (state = initialState, { current }) => ({ ...state, configFile: { ...state.configFile, current } }),
}

export const reducer = createReducer(initialState, handlers)

export default Creators



// WEBPACK FOOTER //
// src/store/redux/superadmin.js